<template>
  <div class="year-main-content">
    <div class="year-top-image" v-bind:style="{ backgroundImage: 'url(' + require('@/assets/' + topImage) + ')' }">
    <div class="year-overlay"><span>2017</span></div>
    </div>
    <div class="view-wrap yr2017">


<FullYearStats fullGames='16' fullCompletions='386' fullAttempts='536' fullYards='4,334' fullPct='72.0' fullTDs='23' fullINTs='8' fullYPG='270.9' fullRating='103.9'></FullYearStats>

  <div class="year-summary-wrapper">
    <div class="triangle-top-left"></div>
    <div class="triangle-bottom-right"></div>
    <div class="year-summary">
    
      <div class="year-summary-text-flex">

<h1 class="content-headline">Back in the playoffs</h1>

      <div class="copy-paragraph">

      Bolstered by a stronger-than-ever running attack, Brees’ numbers dipped slightly, but he was more efficient than ever. Equally important to the team’s success was a young and revitalized defense that took some of the pressure off Brees to win games. The Saints shook off some early growing pains to finish 11-5, including an eight-game winning streak.
      <br/><br/>

      Brees completed 386-of-536 passes (72.0%) for 4,334 yards, 23 touchdowns and a 103.9 rating with only eight interceptions over 16 starts. He set the NFL single-season mark for completion percentage.<br/><br/>

      In addition to the completion percentage record, Brees ranked first in the NFL in completions, second in passer rating, third in fourth quarter passer rating (117.6) and fourth in passing yardage. Drew was also named to a club-record tenth Pro Bowl as a Saint, 11th in his career.<br/><br/>

      In two playoff games, Drew completed 48-of-73 attempts for 670 yards with five touchdowns, three interceptions and a 100.8 rating.<br/><br/>
      </div>

      <div class="copy-paragraph">
      <img :src="require('@/assets/brees-2017-img-in-copy.jpg')" style="width:100%;" alt="Drew Brees running off the field postgame with one of his record-breaking game-balls">
      </div>


<div class="awards-wrapper">
        <div class="awards-headline">2017 Awards</div>
        <ul>

          <li><img :src="require('@/assets/pro-bowl.png')" alt="Pro Bowl Logo"> 2017 Pro Bowl</li>
          <li><img :src="require('@/assets/castrol-edge.png')" alt="Castrol Edge Logo"> Castrol Edge Clutch Performer of the Year</li>
          
        </ul>
        <div class="awards-legend">
<b>AP</b> - Associated Press, <b>CN</b> - College & Pro Football Weekly, <b>FD</b> -Football Digest, <b>FN</b> -Football News, <b>FW</b> - Professional Football Writers of America, <b>NE</b> - Newspaper Enterprise Association, <b>NY</b> - New York Daily News, <b>PFWA</b> - Pro Football Writers of America, <b>PW</b> - Pro Football Weekly(1992-2012,choices combined with Pro Football Writers of America), <b>SI</b> - Sports Illustrated, <b>SN</b> - Sporting News, <b>UP</b> - United Press International, <b>UW</b> - USA Today/Sports Weekly
        </div>
      </div> 
      </div> <!--end text-flex-->
    </div>
  </div>

   <div class="bubble-chart-wrapper chart-light">
      <h2 class="chart-headline">Top Rated QBs of 2017</h2>
      <BubbleChart :chart-data="dataBubble1" :options="dataOptions3" style="height:400px;"></BubbleChart>
    </div>

<div class="touchdowns-header-wrapper">
  <h1><img src="https://nolaprodigital.com/saints/brees500/images/referee-icon-white.png" alt="Drew Brees 2017 Touchdown Tally"> 2017 TOUCHDOWN TALLY</h1>
</div>







</div>


<TDsByYear :tds="this.tds"></TDsByYear>



<flickity ref="flickity" :options="flickityOptions">
  <div class="carousel-cell"><img :src="require('@/assets/' + image1)" alt="Drew Brees in 2017 - Slide1"></div>
  <div class="carousel-cell"><img :src="require('@/assets/' + image2)" alt="Drew Brees in 2017 - Slide2"></div>
  <div class="carousel-cell"><img :src="require('@/assets/' + image3)" alt="Drew Brees in 2017 - Slide3"></div>
  <div class="carousel-cell"><img :src="require('@/assets/' + image4)" alt="Drew Brees in 2017 - Slide4"></div>
  <div class="carousel-cell"><img :src="require('@/assets/' + image5)" alt="Drew Brees in 2017 - Slide5"></div>
  <div class="carousel-cell"><img :src="require('@/assets/' + image6)" alt="Drew Brees in 2017 - Slide6"></div>
  <div class="carousel-cell"><img :src="require('@/assets/' + image7)" alt="Drew Brees in 2017 - Slide7"></div>
  <div class="carousel-cell"><img :src="require('@/assets/' + image8)" alt="Drew Brees in 2017 - Slide8"></div>
</flickity>


<div class="year-pagination-wrapper">
  <div class="year-pagination-section year-pagination-prev"><router-link to="/year/2016">«2016</router-link></div>
  <div class="year-pagination-section year-pagination-current">2017</div>
  <div class="year-pagination-section year-pagination-next"><router-link to="/year/2018">2018»</router-link></div>
</div>



    </div>
  </div>
</template>

<script>
// @ is an alias to /src
import StatsFlex from '@/components/StatsFlex.vue'
import Flickity from 'vue-flickity';
import VideoBtn from '@/components/VideoBtn.vue';
import FullYearStats from '@/components/FullYearStats.vue';
import TDsByYear from '@/components/TDsByYear.vue';
import BubbleChart from '@/components/BubbleChart.vue'

import axios from 'axios';

export default {
  name: 'yr2017',
  components: {
    Flickity,
    StatsFlex,
    VideoBtn,
    FullYearStats,
    TDsByYear,
    BubbleChart
  },
  metaInfo: {
    title: 'Drew Brees Stats and Touchdowns from his 2017 season',
    htmlAttrs: {
      lang: 'en'
    }
  },
  data() {
    return {
      dataCollection: {},
      dataOptions:{},
      tds: {},
      loading: false,
      games: [],
      topImage: "brees-2017-top.jpg",
      image1: "brees-2017-slide-1.jpg",
      image2: "brees-2017-slide-2.jpg",
      image3: "brees-2017-slide-3.jpg",
      image4: "brees-2017-slide-4.jpg",
      image5: "brees-2017-slide-5.jpg",
      image6: "brees-2017-slide-6.jpg",
      image7: "brees-2017-slide-7.jpg",
      image8: "brees-2017-slide-8.jpg",

      flickityOptions: {
            initialIndex: 0,
            prevNextButtons: false,
            pageDots: false,
            resize: true,
            wrapAround: true,
            autoPlay: true

            // any options from Flickity can be used
            }

          } 
        },
  methods: {
    async getTDs() {
      const self = this;
      const response = await axios.get(
        "../../static/td-data.json"
      );
      this.tds = response.data.y2017;
      console.log(this.tds)
    },
    next() {
      this.$refs.flickity.next();
    },

    previous() {
      this.$refs.flickity.previous();
    },
    resize() {
      this.$refs.flickity.resize();
    }
  },

   mounted: function() {
    this.getTDs();

    setTimeout(() => {
    this.$refs.flickity.resize();
    }, 2000)

  },

    created() {
       this.dataBubble1 = {
      "datasets": [
      {
        "label": "Drew Brees",
        "backgroundColor": "black",
        "borderColor": "#D3BC8D",
        "fill": false,
        "pointBackgroundColor": '#D3BC8D',
        "pointColor": "#D3BC8D",
        "pointRadius": 100,
        hoverRadius: 0,
        borderWidth: 3,
        hoverBorderWidth:3,
        "pointHighlightFill": "#D3BC8D",
        data: [
                {
                  x: 23,
                  y: 72.1,
                  r: 11*2
                }
              ]
      },
      {
        "label": "Tom Brady",
        "backgroundColor": "#002244",
        "borderColor": "#C60C30",
        "fill": false,
        "pointRadius": 7,
        hoverRadius: 0,
        borderWidth: 3,
        hoverBorderWidth:3,
        "pointHighlightFill": "#C60C30",
        data: [
                {
                  x: 32,
                  y: 66.3,
                  r: 8*2
                }
              ]
      },
      {
        "label": "Alex Smith",
        "backgroundColor": "#FFB81C",
        "borderColor": "#E31837",
        "fill": false,
        "pointRadius": 7,
        hoverRadius: 0,
        borderWidth: 3,
        hoverBorderWidth:3,
        "pointHighlightFill": "#C60C30",
        data: [
                {
                  x: 26,
                  y: 67.5,
                  r: 5*2
                }
              ]
      },
      {
        "label": "Carson Wentz",
        "backgroundColor": "#004C54",
        "borderColor": "#A5ACAF",
        "fill": false,
        "pointRadius": 7,
        hoverRadius: 0,
        borderWidth: 3,
        hoverBorderWidth:3,
        "pointHighlightFill": "#C60C30",
        data: [
                {
                  x: 33,
                  y: 60.2,
                  r: 7*2
                }
              ]
      },
      {
        "label": "Jared Goff",
        "backgroundColor": "#024",
        "borderColor": "#866D4B",
        "fill": false,
        "pointRadius": 7,
        hoverRadius: 0,
        borderWidth: 3,
        hoverBorderWidth:3,
        "pointHighlightFill": "#C60C30",
        data: [
                {
                  x: 28,
                  y: 62.1,
                  r: 7*2
                }
              ]
      }
      ]
    },
    this.dataOptions3 = {
        "responsive": true,
        "maintainAspectRatio": false,
        title: {
            display: true,
            text: '2017 TOP QBs (Bubble size is interceptions)'
        },
        "layout": {
          padding: {
                left: 10,
                right: 10,
                top: 0,
                bottom: 0
          },
        },
        "legend": {
          "position" : "bottom",
            "maxSize" : {
                "height" : 400
            },
            "labels": {
                "fontColor": "black",
                "fontSize": 14,
                "usePointStyle" : true
            }
        },
        tooltips: {
          "mode": "point",
          callbacks: {
              label: function(tooltipItem, data) {
                 var rLabel = data.datasets[tooltipItem.datasetIndex].data[tooltipItem.index].r;
                  var datasetLabel = data.datasets[tooltipItem.datasetIndex].label || '';
                  return datasetLabel + ' : ' + tooltipItem.yLabel + ' Completion %, ' + tooltipItem.xLabel + ' TDs, ' + rLabel/2 + ' INTs';
              }
          }
        },
        "scales": {
          "yAxes": [{
            scaleLabel: {
              display: true,
              labelString: 'Completion Percentage'
            },
            gridLines: {
              color: '#D3BC8D',
              tickMarkLength: 20,
              lineWidth: .2
                },
            "ticks": {
              "fontColor": 'black',
              callback: function(value, index, values) {
                        return value + '%';
                    },
            },
          }],
          "xAxes": [{
            scaleLabel: {
              display: true,
              labelString: 'Touchdown Passes'
            },
            gridLines: {
              color: '#D3BC8D',
              tickMarkLength: 20,
              lineWidth: .2
            },
            "ticks": {
              
              "fontColor": 'black'
            },
          }]
        }
    }

    }
}
</script>

<style>

.year-top-image > img {
  width:100%;
}


@media (max-width:767px;) {
  .year-main-content {
  margin-top:35px;
  }
}
</style>


// WEBPACK FOOTER //
// src/views/yr2017.vue